import { useCallback, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
// material
import { styled, useTheme } from '@mui/material/styles';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { useDispatch, useSelector } from 'react-redux';
import { firestore } from '../../contexts/FirebaseContext';
import { getFirebaseActualRol, getRolesAction } from '../../redux/slices/DagpacketRoles';
import { settingsFunctionsCollection } from '../../constants/rolesConfPermissions';
import { getSettingsFuncAction } from '../../redux/slices/settingsFunctions';
import useAuthUsers from '../../hooks/useAuthUsers';
import { restartCartAction } from '../../redux/slices/dagpacket';
import { restartCartServRecAction } from '../../redux/slices/dagpacketServRec';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  // const { userTypeId } = useRole();
  const dispatch = useDispatch();
  const { currentUser } = useAuthUsers();

  // ------lista de roles existente

  const getRoles = useCallback(async () => {
    firestore.collection('roles').onSnapshot((queryS) => {
      const dat = [];
      queryS.forEach((doc) => {
        dat.push({
          id: doc.id,
          ...doc.data()
        });
      });

      dispatch(getRolesAction(dat));
    });
  }, [dispatch]);

  // -------rol actual del usuario
  const getActualRol = useCallback(async () => {
    firestore
      .collection('roles')
      .doc(currentUser?.role)
      .onSnapshot((doc) => {
        // console.log(doc.data());
        dispatch(getFirebaseActualRol(doc.data()));
      });
  }, [currentUser, dispatch]);

  // ----- lista de las configuraciones de la app
  const getConfSettings = useCallback(async () => {
    firestore.collection('settings_conf').onSnapshot((snapshot) => {
      const dat = [];
      snapshot.forEach((doc) => {
        dat.push({
          id: doc.id,
          ...doc.data()
        });
      });
      // console.log('el snapshot', dat);
      dispatch(getSettingsFuncAction(dat));
    });
  }, [dispatch]);

  useEffect(() => {
    getActualRol();
    getRoles();
    getConfSettings();
  }, [getRoles, getActualRol, getConfSettings]);

  // ------- ingresar lista de items del localstorage a la cart

  useEffect(() => {
    const itemsList = JSON.parse(localStorage.getItem('cart') || '[]');
    const itemsListServrEC =
      localStorage.getItem('cartServRec') === undefined || localStorage.getItem('cartServRec') === 'undefined'
        ? JSON.parse('[]')
        : JSON.parse(localStorage.getItem('cartServRec'));

    dispatch(restartCartAction(itemsList));
    dispatch(restartCartServRecAction(itemsListServrEC));
  }, [dispatch]);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
      <MainStyle
        sx={{
          transition: theme.transitions.create('margin', {
            duration: theme.transitions.duration.complex
          }),
          ...(collapseClick && {
            ml: '102px'
          })
        }}
      >
        <Outlet />
      </MainStyle>
    </RootStyle>
  );
}
